import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Testimonials() {
  const headerAnimation = useScrollAnimation({ threshold: 0.2 });
  const cardsAnimation = useScrollAnimation({ threshold: 0.1 });
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const testimonials = [
    {
      image: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/cd972ee80133e3c2ae9cdc8ba7baee22.jpeg',
      petName: 'ヨークシャテリア サランちゃん',
      catchphrase: '愛犬と同じ名前のスプレーで、毎日のケアが特別な時間に',
      text: `うちの犬と同じ名前の商品というのが、一番のお気に入りポイント♪サランヘヨのサラン。愛する我が家の姫に、ぴったりのスプレーです。商品の感想としては、ラグジュアリーなのに、強すぎない上品な香りが気に入ってますし、サランも嫌がらずにむしろこのスプレーをつけてあげると大人しくブラッシングさせてくれます。香りも皮膚に対する負担も無さそうでサランが気持ちよさそうな顔をしてくれるのでとても嬉しいです。ヨーキーは毛が伸びるし抜けるので今までたくさんスプレー、シャンプー使ってきましたがここまでサランも私たちも気に入った物がなくやっと出会えて求めていた物なので嬉しいです。毛をサラつやにするだけでなく、静電気も防いでくれる機能的商品なので毎日の習慣にぴったりでうちは、お出かけが多いので、飛行機内で持込ができる100mlのスプレーボトルの形状もライフスタイルに合っています。セレブリティなゴールドラベルも素敵でお友達へのプレゼントにもぴったり周りもみんなバッグに入れて持ち運んでいます!また、ペット可のところに入る時も軽くスプレーしてあげると良い香りになり色んな方からどこのシャンプーですか?トリミング毎日されてますか?と聞かれるくらい毛並みも肌も綺麗になりました。サランスプレー最高サランへヨ♡`,
      author: 'ヨークシャテリア サランちゃん 飼い主様'
    },
    {
      image: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/8e87d735046b74a82f9711b097b610ac.png',
      petName: '秋田犬 暖木(のんき)愛姫(めごひめ)ちゃん',
      catchphrase: '大型犬の日常ケアが、こんなに簡単に',
      text: `秋田犬を飼っていますが、大型犬ゆえに頻繁にお風呂に入れるのはとても大変で、日頃のケアには悩んでいました。このスプレーは、ブラッシングのタイミングでサッと使えるので、とても助かっています。スプレーしたあとには、ふんわりとやさしい香りが広がり、思わず抱きしめたくなるほど。人工的ではない自然な香りで、犬も嫌がることなく落ち着いた様子で受け入れてくれます。保湿成分など肌にやさしい成分が入っているとのことで、体だけでなく顔まわりにも安心して使えています。もともと、犬用のケア用品には「本当に大丈夫かな?」と不安を感じることが多いのですが、こちらは飼い主である僕らが使用しているスキンケアブランドのペットラインですので、自分が使っているコスメのメーカーという点で、信頼して使うことができました。実際、毛並みも整いやすくなり、香りもほどよく持続するので、お出かけ前のひと手間にもぴったりです。忙しい日々の中でも犬のケアをやさしく続けられる一本。こういうアイテムがもっと増えてほしいと感じる、満足度の高い商品です。`,
      author: '秋田犬 暖木(のんき)愛姫(めごひめ)ちゃん 飼い主様'
    },
    {
      image: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/8189d8290dd3e19103a4aa1ff2e41d10.png',
      petName: 'ベンガルネコ ちゃるちゃん',
      catchphrase: 'ブラッシングが苦手な猫ちゃんにも、ハンドグルーミングで',
      text: `短毛種なので、グルーミングミストを使った事がありませんでしたが、換毛期に手にミストを吹きかけ、バンドグルーミングをしてあげると、毛も取れて、かつ被毛もしっとりいい匂いに。ブラッシングが苦手な犬猫ちゃんでも、ハンドグルーミングにもピッタリな商品だと思いました。`,
      author: 'ベンガルネコ ちゃるちゃん 飼い主様'
    },
    {
      image: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/e0e1bf418626bb596a0f49ffdfdddcbb.png',
      petName: 'チワワ×ポメラニアンMIX らいちゃん',
      catchphrase: '室内犬の匂いケアに、飼い主も癒される香り',
      text: `室内犬のため、匂いケアには、とても気を使っています。このスプレーは、とにかくいい香りで、飼い主も香りに癒されています。嫌がるかなと心配しましたが、問題なく使えているので、オススメです!`,
      author: 'チワワ×ポメラニアンMIX らいちゃん 飼い主様'
    },
    {
      image: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/004a047e7f6bfe96857491b9229970bb.png',
      petName: 'シェルティー　モノちゃん',
      catchphrase: 'ずっと気になっていた匂いが本当に軽くなって嬉しい',
      text: `うちの子は毛量が多く、どうしても湿気や散歩後の空気を吸いやすいせいか、首元や胸のあたりに特有の"犬の匂い"が残りがちでした。強い香りでごまかすタイプのスプレーは苦手で、本人も嫌がるためずっと悩んでいました。Sarang Sprayを使ってまず驚いたのは、香りの質の良さと軽さです。ふわっと清潔感のあるホワイトリリーが広がるのに、強く主張せず、あくまで自然に寄り添ってくれるような香り方。大きな体でも、全身に使っても香りが"重くならない"のが嬉しいポイントです。家の中で抱きしめたとき、ふわっと漂う優しい香りに、家族みんなが癒されています。長毛で匂いがこもりやすい子にこそ、ぜひ試してほしい逸品です。`,
      author: 'シェルティー　モノちゃん 飼い主様'
    },
    {
      image: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/cd382dff197b50ba4f20ec53bf1c4e38.png',
      petName: 'パピヨン ハクちゃん',
      catchphrase: '繊細な飾り毛もスッと整って嬉しい',
      text: `香りがめっちゃ良くて、スプレーしてからブラッシングすると、毛がふわふわになってます。
使い始めた日は、本人は耳の近くにスプレーすると　カーペットにこすりつけて、
耳の近くに、スプレーされるのを嫌いなのかもしれません。
DeaiwoSarangSprayだけではなく、シャンプーあとなど、匂いがする日は、
体をこすりつけています。
翌日、体だけにスプレーしてみることにしました。
体だけスプレーすると、カーペットにこすりつける動きもせず、全く　嫌がるそぶりがなかったので
体だけにスプレーするやりかたで、慣らしました。

今でも、耳にスプレーすると、カーペットにこすりつけますが、その動きも　すぐやめるので、
本当に嫌なわけではないなと感じて、家族みんなで香りに癒されて、愛用しています。`,
      author: 'パピヨン ハクちゃん 飼い主様'
    },
    {
      image: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/dfc8ed99307fe0e2ea97f50281732f79.png',
      petName: 'ダックス　吟ちゃん',
      catchphrase: '強い香りが苦手なうちの子でも、逃げずに使えます',
      text: `短毛の為、油っぽくニオイも強めなので、香りの強い被毛ケア商品を使っていましたが、匂いが嫌いなのか逃げ出すことが多かったです。
DeaiwoSarangSprayは、優しい香りで嫌がる事なく、体臭を抑えてくれるので愛用しています。`,
      author: 'ダックス　吟ちゃん 飼い主様'
    }
  ];

  return (
    <section className="py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div 
          ref={headerAnimation.ref}
          className={`text-center mb-20 space-y-6 transition-all duration-1000 ${headerAnimation.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
        >
          <h3 className="text-sm tracking-[0.3em] text-stone-500 font-light" style={{ fontFamily: 'Cormorant, serif' }}>
            TESTIMONIALS
          </h3>
          <h2 className="text-4xl md:text-5xl leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
            飼い主様の声
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div 
          ref={cardsAnimation.ref}
          className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto"
        >
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className={`bg-white overflow-hidden transition-all duration-1000 ${cardsAnimation.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full p-8 text-left cursor-pointer group hover:bg-stone-50/50 transition-colors"
              >
                <div className="space-y-6">
                  {/* Pet Image */}
                  <div className="w-32 h-32 mx-auto overflow-hidden rounded-full">
                    <img
                      src={testimonial.image}
                      alt={testimonial.petName}
                      className="w-full h-full object-cover object-top scale-115"
                    />
                  </div>
                  
                  {/* Pet Name */}
                  <h4 className="text-center text-lg" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
                    {testimonial.petName}
                  </h4>

                  {/* Catchphrase with Icon */}
                  <div className="flex items-start gap-3 px-6">
                    <p 
                      className="flex-1 text-lg md:text-xl leading-relaxed" 
                      style={{ 
                        fontFamily: 'Noto Serif JP, serif', 
                        fontWeight: 600,
                        color: '#705e44' 
                      }}
                    >
                      {testimonial.catchphrase}
                    </p>
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-[#C6A87B] transition-transform duration-300" style={{ transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                      <i className="ri-arrow-down-s-line text-2xl"></i>
                    </div>
                  </div>
                </div>
              </button>

              {/* Expandable Content */}
              <div 
                className={`overflow-hidden transition-all duration-500 ${openIndex === index ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="px-8 pb-8 space-y-6">
                  {/* Quote Mark */}
                  <div className="text-4xl text-[#C6A87B] opacity-30" style={{ fontFamily: 'Playfair Display, serif' }}>
                    "
                  </div>

                  {/* Testimonial Text */}
                  <p className="text-sm leading-loose" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
                    {testimonial.text}
                  </p>

                  {/* Author */}
                  <div className="pt-4 border-t border-stone-200">
                    <p className="text-sm text-stone-500" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
                      {testimonial.author}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}